import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../../uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../uicomponentview';
import { LanguageViewImpl } from './languageview';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { LanguageCSSStyleImpl } from './languagecss';
import { LanguageConst } from '../../../../utils/resources/languageconst';

export interface LanguageComponentProps extends UIComponentProps
{
   fontSize?: string;
   onLanguageChange(languageSelected: LanguageConst): void;
}

export interface LanguageComponentState extends UIComponentState
{
    languageSelected: string;
}

export interface LanguageComponentHandler extends UIComponentHandler
{
    onLangaugeSelected(language: string): void;
}

export class LanguageComponent extends UIComponentImpl<LanguageComponentProps, LanguageComponentState, UIDataModel> 
    implements LanguageComponentHandler
{
    constructor(props: LanguageComponentProps)
    {
        super(props);

        this.state = {languageSelected: props.context.getUserContext().getLanguage()};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new LanguageViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new LanguageCSSStyleImpl(applicationContext);
    }

    UNSAFE_componentWillReceiveProps(props: LanguageComponentProps)
    {
        this.setState({languageSelected: props.context.getUserContext().getLanguage()});
    }

    onLangaugeSelected(languageSelected: LanguageConst) 
    {
        this.props.onLanguageChange(languageSelected);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/header/language/languagecomponent.tsx